var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackAccessActiveBlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-82-Copy-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFBD09",
    cx: 10,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89978412,9.00010477 C8.66794062,10.1409563 7.65919113,10.9995655 6.44990271,10.9995655 C5.24061428,10.9995655 4.23186479,10.1409563 4.00002129,9.00010477 Z",
    id: "Combined-Shape-Copy-12",
    fill: "#333B47",
    transform: "translate(6.449903, 9.999783) scale(1, -1) rotate(-360.000000) translate(-6.449903, -9.999783) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,15 C7.5412844,15.5922768 8.68119266,16 10,16 C11.3188073,16 12.4587156,15.5922768 13,15",
    id: "Stroke-1",
    stroke: "#333B47",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(10.000000, 15.500000) scale(-1, 1) translate(-10.000000, -15.500000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-15",
    fill: "#333B47",
    cx: 13,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "LUI-icon-pd-add-solid-16",
    transform: "translate(14.000000, 0.000000)",
    fill: "#0BC7C2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    points: "8 5 5 5 5 8 3 8 3 5 0 5 0 3 3 3 3 0 5 0 5 3 8 3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackAccessActiveBlink);
export default __webpack_public_path__ + "static/media/feedback-access-active-blink.812e777ab07346f96f6538e90d82933d.svg";
export { ForwardRef as ReactComponent };